/**
 *  Layers script file
**/

export default {
  name: 'Layers',
  mixins: [],
  components: {},
  props: {
    layers: {
      type: Array,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {
  },
  methods: {
    close () {
      this.$refs.dropdown.close()
    },
    onCheckboxChange (layer) {
      this.$emit('change', layer)
    },
    gradient (range) {
      return `linear-gradient(to right, ${range.join(',', '')})`
    },
    enterLayer (element) {
      element.style.height = 'auto'
      const height = getComputedStyle(element).height
      element.style.height = 0
      // eslint-disable-next-line
      window.getComputedStyle(element).height
      setTimeout(() => {
        element.style.height = height
      })
    },
    afterEnterLayer (element) {
      element.style.height = 'auto'
    },
    leaveLayer (element) {
      const height = getComputedStyle(element).height
      element.style.height = height
      // eslint-disable-next-line
      window.getComputedStyle(element).height
      setTimeout(() => { element.style.height = 0 })
    }
  }
}
